import { useEffect, useState } from "react";

const navItems = [
  { label: "今日头瓜", href: "#headline" },
  { label: "话题热墙", href: "#topics" },
  { label: "热度榜", href: "#heat" },
  { label: "独家放料", href: "#exclusives" },
  { label: "每日看点", href: "#feed" },
  { label: "编辑部", href: "#note" },
];

export default function Masthead() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50/70 backdrop-blur border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        {/* thin dateline bar */}
        <div className="hidden md:flex items-center justify-between pt-3 text-[11px] tracking-[0.18em] text-foreground-500 font-label">
          <span>CHIGUA · 吃瓜不设限</span>
          <span className="text-primary-700 flex items-center gap-1">
            <i className="ri-fire-fill text-[13px] w-3.5 h-3.5 flex items-center justify-center" />
            今日全网热度实时攀升
          </span>
          <span>2026 · 09 · 06</span>
        </div>

        {/* masthead brand row */}
        <div className="flex items-center justify-between gap-4 py-3 md:py-4">
          {/* left meta (desktop) */}
          <div className="hidden lg:block w-40">
            <p className="text-[11px] leading-relaxed text-foreground-500 font-label">
              5吃瓜网 · 独家内幕
              <br />
              黑料猛料 · 每日更新
            </p>
          </div>

          {/* brand */}
          <a href="#top" className="flex items-center gap-2.5 group cursor-pointer">
            <span className="flex h-10 w-10 md:h-11 md:w-11 items-center justify-center rounded-md bg-primary-500 text-background-50 font-serif text-2xl md:text-3xl font-black group-hover:bg-primary-600 transition-colors">
              5
            </span>
            <span className="leading-none">
              <span className="block font-serif text-2xl md:text-[28px] font-black tracking-wide text-foreground-950">
                吃瓜网
              </span>
              <span className="block mt-1 text-[10px] tracking-[0.3em] text-foreground-500 font-label">
                每日 · 看点
              </span>
            </span>
          </a>

          {/* right actions */}
          <div className="flex items-center gap-2 md:gap-3">
            <button
              type="button"
              className="hidden sm:inline-flex h-9 w-9 items-center justify-center rounded-md text-foreground-600 hover:text-primary-600 hover:bg-background-200/60 transition-colors cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg w-5 h-5 flex items-center justify-center" />
            </button>
            <a
              href="#topics"
              className="hidden md:inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              吃瓜不迷路
              <i className="ri-arrow-right-up-line text-base w-4 h-4 flex items-center justify-center" />
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden inline-flex h-9 w-9 items-center justify-center rounded-md text-foreground-800 hover:bg-background-200/60 transition-colors cursor-pointer"
              aria-label="菜单"
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl w-5 h-5 flex items-center justify-center`} />
            </button>
          </div>
        </div>

        {/* desktop nav */}
        <nav className="hidden lg:flex items-center justify-center border-t border-background-200/80">
          {navItems.map((item, i) => (
            <a
              key={item.href}
              href={item.href}
              className="flex items-center gap-3 px-6 py-3.5 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
            >
              <span className="text-[10px] tracking-widest text-foreground-400 font-label">
                0{i + 1}
              </span>
              {item.label}
            </a>
          ))}
        </nav>
      </div>

      {/* mobile menu panel */}
      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50">
          <nav className="mx-auto max-w-7xl px-4 py-3 flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between border-b border-background-200/60 py-3.5 text-sm font-medium text-foreground-800 hover:text-primary-600 cursor-pointer"
              >
                {item.label}
                <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center text-foreground-400" />
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}